module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-loader"
  }, [_c('div', {
    staticClass: "cb-loader__bar",
    style: (_vm.backgroundColor)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b792d628"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collections/elements/Loader.vue
// module id = 135
// module chunks = 83 84 85 86